/* Kevora custom product page: gallery, variants, add to cart, lightbox, sticky bar */
(function () {
  'use strict';
  function init(root) {
    if (!root || root._tppInit) return;
    root._tppInit = true;
    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return [].slice.call((c || root).querySelectorAll(s)); };
    var dataEl = $('[data-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    var track = $('[data-track]');
    var slides = $$('.tpp__slide');
    var thumbs = $$('.tpp__thumb');
    var countEl = $('[data-current]');
    var form = $('[data-form]');
    var idInput = $('[data-variant-id]');
    var qtyInput = $('[data-qty-input]');
    var addBtn = $('[data-add]');
    var buyBtn = $('[data-buy]');
    var msg = $('[data-msg]');
    var priceEl = $('[data-price]');
    var compareEl = $('[data-compare]');
    var saveEl = $('[data-save]');
    var stockEl = $('[data-stock]');
    var bar = $('[data-bar]');
    var barPrice = $('[data-bar-price]');
    var barAdd = $('[data-bar-add]');
    var labelAdd = addBtn ? addBtn.getAttribute('data-label') : 'Add to cart';
    var labelSold = addBtn ? addBtn.getAttribute('data-sold') : 'Sold out';
    var labelAdded = addBtn ? addBtn.getAttribute('data-added') : 'Added';
    var addLabelEl = $('[data-add-label]');
    var busy = false;

    function goTo(i) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function setActive(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (countEl) countEl.textContent = i + 1;
      var t = thumbs[i];
      if (t && t.parentNode) {
        var rail = t.parentNode;
        if (rail.scrollHeight > rail.clientHeight + 2) rail.scrollTop = t.offsetTop - rail.clientHeight / 2 + t.offsetHeight / 2;
        else if (rail.scrollWidth > rail.clientWidth + 2) rail.scrollLeft = t.offsetLeft - rail.clientWidth / 2 + t.offsetWidth / 2;
      }
    }
    function currentIndex() { return track ? Math.round(track.scrollLeft / (track.clientWidth || 1)) : 0; }
    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; setActive(currentIndex()); });
      }, { passive: true });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
    $$('[data-nav]').forEach(function (b) {
      b.addEventListener('click', function () { goTo(currentIndex() + parseInt(b.getAttribute('data-nav'), 10)); });
    });

    var lb = null, lbIndex = 0;
    function lbShow(i) {
      lbIndex = (i + slides.length) % slides.length;
      var z = slides[lbIndex].querySelector('[data-full]');
      if (z && lb) lb.querySelector('img').src = z.getAttribute('data-full');
    }
    function lbClose() { if (lb) { lb.remove(); lb = null; document.removeEventListener('keydown', lbKey); } }
    function lbKey(e) {
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
      else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
    }
    function lbOpen(i) {
      lb = document.createElement('div');
      lb.className = 'tpp__lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-label', 'Image viewer');
      lb.innerHTML = '<img alt=""><button type="button" class="tpp__lb-close" aria-label="Close">&times;</button>' +
        (slides.length > 1 ? '<button type="button" class="tpp__lb-prev" aria-label="Previous">&#8249;</button><button type="button" class="tpp__lb-next" aria-label="Next">&#8250;</button>' : '');
      document.body.appendChild(lb);
      lbShow(i);
      lb.addEventListener('click', function (e) {
        if (e.target.classList.contains('tpp__lb-prev')) lbShow(lbIndex - 1);
        else if (e.target.classList.contains('tpp__lb-next')) lbShow(lbIndex + 1);
        else if (e.target === lb || e.target.classList.contains('tpp__lb-close')) lbClose();
      });
      document.addEventListener('keydown', lbKey);
    }
    $$('[data-zoom]').forEach(function (b) {
      b.addEventListener('click', function () { lbOpen(parseInt(b.getAttribute('data-zoom'), 10) || 0); });
    });

    function selected() {
      return $$('[data-option-index]').map(function (fs) {
        var c = fs.querySelector('input[type=radio]:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < sel.length; k++) { if (v.options[k] !== sel[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function setAvail(ok, label) {
      [addBtn, buyBtn, barAdd].forEach(function (b) { if (b) b.disabled = !ok; });
      if (addLabelEl) addLabelEl.textContent = label;
      if (barAdd) barAdd.textContent = label;
    }
    function applyVariant(userChange) {
      var sel = selected();
      $$('[data-option-index]').forEach(function (fs, k) {
        var l = fs.querySelector('[data-opt-label]');
        if (l && sel[k]) l.textContent = sel[k];
      });
      if (!variants.length || !sel.length) return;
      var v = findVariant(sel);
      if (!v) {
        setAvail(false, labelSold);
        if (msg) { msg.textContent = 'This combination is unavailable.'; msg.classList.add('is-error'); }
        return;
      }
      if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (barPrice) barPrice.textContent = v.price;
      if (compareEl) { compareEl.hidden = !v.compare; if (v.compare) compareEl.textContent = v.compare; }
      if (saveEl) { saveEl.hidden = !v.compare; if (v.compare) saveEl.textContent = v.save + '% off'; }
      if (stockEl) {
        var low = v.available && v.qty !== null && v.qty > 0 && v.qty <= 5;
        stockEl.hidden = !low;
        if (low) stockEl.textContent = 'Only ' + v.qty + ' left';
      }
      setAvail(v.available, v.available ? labelAdd : labelSold);
      if (window.history && history.replaceState) {
        history.replaceState(null, '', location.pathname + '?variant=' + v.id);
      }
      if (userChange && v.media) {
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].getAttribute('data-media-id')) === String(v.media)) { goTo(i); break; }
        }
      }
    }
    $$('input[data-opt]').forEach(function (r) {
      r.addEventListener('change', function () { applyVariant(true); });
    });

    $$('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10);
        qtyInput.value = Math.max(1, Math.min(99, n));
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      qtyInput.value = Math.max(1, Math.min(99, parseInt(qtyInput.value, 10) || 1));
    });

    function updateBubble() {
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(base + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
        var html = j['cart-icon-bubble'];
        var target = document.getElementById('cart-icon-bubble');
        if (!html || !target) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sec = doc.querySelector('.shopify-section');
        if (sec) target.innerHTML = sec.innerHTML;
      }).catch(function () {});
    }
    function addToCart(e) {
      if (e) e.preventDefault();
      if (busy || !addBtn || addBtn.disabled) return;
      busy = true;
      addBtn.classList.add('is-loading');
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart.');
          if (addLabelEl) addLabelEl.textContent = labelAdded;
          if (msg) { msg.classList.remove('is-error'); msg.innerHTML = 'Added to your cart. <a href="' + base + 'cart">View cart</a>'; }
          return updateBubble();
        })
        .catch(function (err) {
          if (msg) { msg.textContent = err.message; msg.classList.add('is-error'); }
        })
        .then(function () {
          busy = false;
          addBtn.classList.remove('is-loading');
          setTimeout(function () { if (!addBtn.disabled && addLabelEl) addLabelEl.textContent = labelAdd; }, 2200);
        });
    }
    if (addBtn) addBtn.addEventListener('click', addToCart);
    if (barAdd) barAdd.addEventListener('click', function () { if (addBtn) addBtn.click(); });
    if (buyBtn && form) {
      form.addEventListener('submit', function (e) {
        var sub = e.submitter;
        if (sub !== buyBtn && !(sub && sub.name === 'return_to')) e.preventDefault();
      });
    }

    if (bar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(addBtn);
    }
    applyVariant(false);
  }
  function initAll() { document.querySelectorAll('[data-tpp]').forEach(init); }
  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();